export const BrandMark = ({ className = "h-8" }: { className?: string }) => (
  <img src="/big-logo.png" alt="Velasco Software" className={className} />
);

export const Wordmark = ({ className = "h-6" }: { className?: string }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <span className="font-extrabold tracking-wider text-slate-100">VELASCO SOFTWARE</span>
  </div>
);
